import dayjs from 'dayjs';
import { MessageId } from '../../messages/message-id';
import { FeServerRequestType, FeServerResponse } from '../../messages/message-json';
import { Message } from '../../messages/message-types';
import { MessageType } from '../../services/actor-messages';
import FeConnection from '../fe-connection';

export enum FlightDebugEntryType {
    binary,
    json
}
export type FlightDebugEntry = {
    id: number;
    flightId: number;
    time: string;
} & (
    | {
          type: FlightDebugEntryType.binary;
          subType: MessageId;
          content: Message;
      }
    | {
          type: FlightDebugEntryType.json;
          content: FeServerResponse;
      }
);

export class MessageDebugger {
    private enabled = false;
    private idSource = 0;
    private messages: Partial<Record<number, FlightDebugEntry[]>> = {};

    constructor(private readonly connection: FeConnection) {}

    private onJsonMessage = (message: FeServerResponse) => {
        if (message.msgType !== FeServerRequestType.FlightData) {
            return;
        }

        if (this.watches(message.recordNum)) {
            this.addJsonyMessage(message.recordNum, message);
        }
    };

    private onBinaryMessage = (id: MessageId, message: any) => {
        const flightId = message.wRecordID ?? message.fwRecordID ?? message.dwRecordID ?? message.wSrvRec;

        if (!flightId || !this.watches(flightId)) {
            return;
        }

        this.addBinaryMessage(flightId, id, message);
    };

    setEnable(value: boolean) {
        if (this.enabled === value) {
            return;
        }
        this.enabled = value;
        if (value) {
            this.connection.messageService.onBinaryMessage(this.onBinaryMessage);
            this.connection.messageService.onJsonMessage(this.onJsonMessage);
        } else {
            this.connection.messageService.offBinaryMessage(this.onBinaryMessage);
            this.connection.messageService.offJsonMessage(this.onJsonMessage);
        }
    }

    public watch(id: number) {
        this.messages[id] = [];
    }

    public unwatch(id: number) {
        delete this.messages[id];
    }

    public watches(id: number) {
        return id in this.messages;
    }

    public addBinaryMessage(id: number, messageId: MessageId, message: any) {
        if (id in this.messages) {
            this.messages[id]!.push({
                id: this.idSource++,
                type: FlightDebugEntryType.binary,
                flightId: id,
                subType: messageId,
                content: structuredClone(message),
                time: dayjs.utc().toISOString()
            });
            this.connection.messageBroker.sendAsync({ type: MessageType.debugFlightMessageAdded, data: this.messages[id]!.at(-1) });
        }
    }

    public addJsonyMessage(id: number, message: FeServerResponse) {
        if (id in this.messages) {
            this.messages[id]!.push({
                id: this.idSource++,
                type: FlightDebugEntryType.json,
                flightId: id,
                content: structuredClone(message),
                time: dayjs.utc().toISOString()
            });
            this.connection.messageBroker.sendAsync({ type: MessageType.debugFlightMessageAdded, data: this.messages[id]!.at(-1) });
        }
    }

    public getForFlight(id: number): FlightDebugEntry[] {
        return this.messages[id] ?? [];
    }
}
